export const agency = {
  // Basic UI translations for BookingSystem
  columns: 'الأعمدة',
  newBooking: 'حجز جديد',
  searchBookings: 'البحث باسم العميل أو المركبة أو مرجع الحجز...',
  selectVehiclePlaceholder: 'اختر مركبة...',
  filterByPeriodPlaceholder: 'تصفية حسب الفترة',
  
  // Missing unique translations for BookingTimelineCalendar only
  invalidFormat: 'تنسيق غير صحيح',
  dateError: 'خطأ في التاريخ',
  unknownClient: 'عميل غير معروف',
  notSpecified: 'غير محدد',
  noVehicleFoundFor: 'لا توجد مركبات لـ',
  noVehicleFound: 'لا توجد مركبات',
  showing: 'عرض',
  to: 'إلى',
  of: 'من',
  rowsPerPage: 'صفوف لكل صفحة',
  previous: 'السابق',
  next: 'التالي',
  idNumber: 'رقم الهوية',
  phoneLabel: 'الهاتف',
  vehicleNotFound: 'المركبة غير موجودة',
  selectStatus: 'اختر الحالة',
  selectDate: 'اختر التاريخ',
  selectTime: 'اختر الوقت',
  calendarVehicles: 'المركبات',
  calendarUnknownClient: 'عميل غير معروف',
  calendarBookingDetails: 'تفاصيل الحجز',
  calendarEdit: 'تعديل',
  calendarCancel: 'إلغاء',
  calendarSaving: 'جاري الحفظ...',
  calendarSave: 'حفظ',
  calendarCustomerInformation: 'معلومات العميل',
  calendarVehicle: 'المركبة',
  calendarSelectVehicle: 'اختر المركبة',
  calendarStatus: 'الحالة',
  calendarConfirmed: 'مؤكد',
  calendarPending: 'في الانتظار',
  calendarCompleted: 'مكتمل',
  calendarCancelled: 'ملغي',
  calendarStartDate: 'تاريخ البداية',
  calendarPickupTime: 'وقت الاستلام',
  calendarEndDate: 'تاريخ النهاية',
  calendarReturnTime: 'وقت الإرجاع',
  calendarPickupLocation: 'موقع الاستلام',
  calendarReturnLocation: 'موقع الإرجاع',
  
  // Table and interface translations  
  customer: 'العميل',
  car: 'المركبة',
  dates: 'التواريخ',
  totalPrice: 'السعر الإجمالي',
  contract: 'العقد',
  actions: 'الإجراءات',
  delete: 'حذف',
  
  // Additional table columns
  createdAt: 'تم الإنشاء في',
  notes: 'ملاحظات',
  
  // Financial information
  bookingInformation: 'معلومات الحجز',
  financialInformation: 'المعلومات المالية',
  additionalInformation: 'معلومات إضافية',
  depositAmount: 'مبلغ العربون',
  bankGuarantee: 'الضمان المصرفي / الضمانة',
  damageAmount: 'رسوم الأضرار',
  
  // Filter and search translations
  searchLabel: 'البحث',
  statusLabel: 'حالة الحجز',
  vehicleLabel: 'المركبة',
  periodLabel: 'الفترة',
  allPeriod: 'جميع الفترات',
  activePeriod: 'الفترة النشطة',
  
  // General UI translations
  selectCarFirst: 'اختر مركبة أولاً',
  selectDateFirst: 'اختر التاريخ أولاً',
  additionalNotesPlaceholder: 'أضف ملاحظات إضافية...',
  createBooking: 'إنشاء حجز',
  
  // Root level location translations (needed for BookingModal)
  selectPickupLocation: 'اختر موقع الاستلام',
  selectReturnLocation: 'اختر موقع الإرجاع',
  locationsAvailable: 'مواقع متاحة',
  carNoLocation: 'هذه المركبة لا تحتوي على موقع مخصص',
  
  // Column customization
  customizeColumns: 'تخصيص الأعمدة',
  resetColumns: 'إعادة تعيين الأعمدة',
  
  // Filter management
  activeFilters: 'المرشحات النشطة',
  clearAllFilters: 'مسح الكل',
  
  // Status options (for direct t('status.pending') calls)
  statusOptions: {
    pending: 'في الانتظار',
    confirmed: 'مؤكد',
    completed: 'مكتمل',
    cancelled: 'ملغي'
  },
  
  // Additional missing root-level translations
  totalBookings: '{{count}} حجوزات',
  
  // Booking status translations
  bookings: {
    // Modal translations
    newBooking: 'حجز جديد',
    editBooking: 'تعديل الحجز',
    customer: 'العميل',
    driver: 'السائق',
    vehicle: 'المركبة',
    searchCustomer: 'البحث عن عميل...',
    selectVehicle: 'اختر المركبة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    extensible: 'قابل للتمديد',
    pickupTime: 'وقت الاستلام',
    returnTime: 'وقت الإرجاع',
    depositAmount: 'مبلغ العربون',
    totalPrice: 'السعر الإجمالي',
    notes: 'ملاحظات',
    
    // Customer related
    noCustomersYet: 'لم يتم إضافة عملاء بعد',
    addFirstCustomer: 'إضافة أول عميل',
    createNewCustomer: 'إنشاء عميل جديد',
    noCustomerFound: 'لم يتم العثور على عميل',
    individual: 'فرد',
    company: 'شركة',
    addNewCustomer: 'إضافة عميل جديد',
    selectAccountType: 'اختر نوع الحساب',
    chooseAccountTypeDesc: 'اختر نوع حساب العميل الذي تريد إنشاؤه',
    personalCustomerAccount: 'حساب عميل شخصي',
    businessCustomerAccount: 'حساب عميل تجاري',
    fullName: 'الاسم الكامل',
    phoneNumber: 'رقم الهاتف',
    identityCardNumber: 'رقم بطاقة الهوية (CIN)',
    residencePermit: 'بطاقة الإقامة (Permis de Séjour)',
    passportNumber: 'رقم جواز السفر',
    drivingLicenseNumber: 'رقم رخصة القيادة',
    iceNumber: 'رقم ICE',
    back: 'رجوع',
    stepOf: 'خطوة {{current}} من {{total}}',
    enterCompanyName: 'اسم الشركة',
    enterClientFullName: 'الاسم الكامل للعميل',
    enterCompanyPhone: 'رقم هاتف الشركة',
    enterClientPhone: 'رقم هاتف العميل',
    enterCinNumber: 'رقم البطاقة الوطنية',
    enterDrivingPermitNumber: 'رقم رخصة القيادة',
    enterIceNumber: 'رقم ICE',
    adding: 'جاري الإضافة...',
    addClient: 'إضافة عميل',
    
    // Date and time
    selectDatePlaceholder: 'اختر التاريخ',
    timePlaceholder: 'اختر الوقت',
    
    // Payment options
    paymentOptions: {
      paid: 'مدفوع',
      partial_paid: 'مدفوع جزئياً',
      unpaid: 'غير مدفوع'
    },
    
    // Validation errors
    selectClientError: 'يرجى اختيار عميل',
    selectVehicleError: 'يرجى اختيار مركبة',
    selectDatesError: 'يرجى اختيار التواريخ',
    totalPriceError: 'السعر الإجمالي يجب أن يكون أكبر من صفر',
    
    // Secondary driver translations
    secondaryDriver: 'السائق الثانوي',
    optional: 'اختياري',
    noSecondaryDriver: 'لا يوجد سائق ثانوي',
    searchSecondaryDriver: 'البحث عن سائق ثانوي...',
    addSecondaryDriver: 'إضافة سائق ثانوي',
    createNewSecondaryDriver: 'إنشاء سائق ثانوي جديد',
    clearSecondaryDriver: 'مسح',
    noCustomersForSecondaryDriver: 'لا يوجد عملاء متاحون للسائق الثانوي',
    noSecondaryDriverFound: 'لم يتم العثور على سائق ثانوي',
    secondaryDriverAdded: 'تم إضافة السائق الثانوي بنجاح',
    errorAddingSecondaryDriver: 'خطأ في إضافة السائق الثانوي',
    selectPickupLocationError: 'يرجى اختيار موقع الاستلام',
    selectReturnLocationError: 'يرجى اختيار موقع الإرجاع',
    cannotSelectDateRange: 'لا يمكن اختيار هذا النطاق الزمني',
    carAvailableFrom: 'ستكون السيارة متاحة من',
    
    // Status translations
    status: {
      pending: 'في الانتظار',
      confirmed: 'مؤكد',
      completed: 'مكتمل',
      cancelled: 'ملغي'
    },
    statusLabel: 'حالة الحجز',
    statusUpdated: 'تم تحديث الحالة بنجاح',
    // Confirm delete booking dialog
    deleteConfirmTitle: 'حذف الحجز',
    deleteConfirmMessage: 'هل أنت متأكد من أنك تريد حذف هذا الحجز؟ لا يمكن التراجع عن هذا الإجراء.',
    deleteSuccess: 'تم حذف الحجز بنجاح',
    deleteError: 'فشل في حذف الحجز',
    createSuccess: 'تم إنشاء الحجز بنجاح',
    updateSuccess: 'تم تحديث الحجز بنجاح',
    cancel: 'إلغاء',
    delete: 'حذف',
    saveError: 'خطأ في حفظ الحجز',
    noBookingsFound: 'لم يتم العثور على حجوزات',
    noBookings: 'لا توجد حجوزات بعد',
    tryDifferentFilter: 'جرب تعديل المرشحات',
    noBookingsDesc: 'ستظهر الحجوزات هنا عندما يقوم العملاء بالحجز.',
    createFirstBooking: 'إنشاء أول حجز',
    allPeriod: 'جميع الفترات',
    days: 'أيام',
    completedBookingTooltip: 'لا يمكن تعديل الحجوزات المكتملة',
    completedAndConfirmedBookings: 'بناءً على الحجوزات المكتملة والمؤكدة'
  },
  
  // Invoice translations
  invoices: {
    title: "الفواتير",
    invoice: "فاتورة",
    invoiceNumber: "رقم الفاتورة",
    totalAmount: "المبلغ الإجمالي",
    status: {
      draft: "مسودة",
      paid: "مدفوع",
      partial_paid: "مدفوع جزئياً",
      canceled: "ملغى",
      sent: "مُرسل",
      overdue: "متأخر"
    },
    invoiceError: "خطأ في إنشاء الفاتورة",
    statusUpdateError: "خطأ في تحديث حالة الفاتورة",
    paidInvoiceProtection: "لا يمكن تعديل الفواتير المدفوعة",
    lockedInvoiceProtection: "لا يمكن تعديل الفواتير المدفوعة والملغاة",
    invoiceLockedTooltip: "لا يمكن تعديل الفواتير المدفوعة والملغاة"
  },
  
  // Contract translations (both root level and nested for compatibility)
  contracts: {
    viewContract: 'عرض العقد',
    downloadPdf: 'تحميل PDF',
    print: 'طباعة',
    generateContract: 'إنشاء عقد',
    contractGenerated: 'تم إنشاء العقد',
    noContract: 'لا يوجد عقد'
  },
  
  // Agency nested namespace for complex translation paths
  agency: {
    invoices: {
      status: {
        draft: 'مسودة',
        paid: 'مدفوع',
        partial_paid: 'مدفوع جزئياً',
        canceled: 'ملغي'
      }
    }
  },
  
  // Main page titles
  agencyDashboard: 'لوحة التحكم',
  dashboardDescription: 'راقب أداء أعمال التأجير والمقاييس الرئيسية',
  bookingsManagement: 'الحجوزات',
  bookingsPageDescription: 'إدارة جميع حجوزات التأجير وحجوزات العملاء',
  
  // Dashboard setup and overview
  vehiclePlanning: 'تخطيط وجدولة الأسطول',
  welcomeToAgency: 'مرحباً بك في وكالة الإيجار الخاصة بك',
  addFirstVehicleMessage: 'ابدأ ببناء أسطول المركبات الخاص بك',
  addFirstVehicle: 'إضافة أول مركبة لك',
  setupStep1: 'قم ببناء أسطولك',
  setupStep1Desc: 'أضف مركبات مع تفاصيل شاملة وأسعار وتوفر',
  setupStep2: 'إدارة قاعدة العملاء',
  setupStep2Desc: 'أنشئ ونظم ملفات العملاء وتاريخ الإيجار',
  setupStep3: 'تتبع عمليات الإيجار',
  setupStep3Desc: 'راقب الحجوزات النشطة والجداول وأداء الإيجار',
  statisticsAnalytics: 'التحليلات التجارية والرؤى',
  
  // Agency Setup
  agencySetup: {
    setupRequired: 'الإعداد مطلوب',
  },
  
  // Locations
  locations: {
    title: 'مواقع الوكالة',
    description: 'إدارة الأماكن التي يمكن استلام وإرجاع المركبات منها',
    addLocation: 'إضافة موقع',
    addNewLocation: 'إضافة موقع جديد',
    editLocation: 'تعديل الموقع',
    searchLocation: 'البحث عن موقع',
    searchPlaceholder: 'البحث في المطارات، محطات القطارات، مراكز المدن...',
    searchHelp: 'ابحث عن المواقع الشائعة أو أضف موقعك المخصص',
    name: 'اسم الموقع',
    namePlaceholder: 'الموقف الرئيسي، المكتب، إلخ.',
    city: 'المدينة',
    cityPlaceholder: 'الدار البيضاء',
    address: 'العنوان',
    addressPlaceholder: 'العنوان الكامل للموقع',
    setAsDefault: 'تعيين كموقع افتراضي',
    noLocations: 'لا توجد مواقع مُكوَّنة',
    noLocationsDesc: 'أضف موقعًا واحدًا على الأقل لبدء إدارة مركباتك',
    addFirstLocation: 'إضافة الموقع الأول',
    default: 'الرئيسي',
    selectLocation: 'اختر الموقع',
    noLocationsAvailable: 'لا توجد مواقع متاحة',
    pickupLocation: 'موقع الاستلام',
    returnLocation: 'موقع الإرجاع',
    selectPickupLocation: 'اختر موقع الاستلام',
    selectReturnLocation: 'اختر موقع الإرجاع',
    selectPickupLocationError: 'يرجى اختيار موقع الاستلام',
    selectReturnLocationError: 'يرجى اختيار موقع الإرجاع'
  },

  // Vehicle Management
  vehicles: {
    title: 'المركبات',
    subtitle: 'إدارة أسطول المركبات الخاص بك',
    addVehicle: 'إضافة مركبة',
    editVehicle: 'تعديل المركبة',
    addFirstVehicle: 'أضف مركبتك الأولى',
    noVehicles: 'لم يتم العثور على مركبات',
    noVehiclesDesc: 'ابدأ بإضافة مركبات إلى أسطولك.',
    totalVehicles: 'تم العثور على {{count}} مركبة',
    searchPlaceholder: 'البحث عن المركبات...',
    
    // Vehicle fields
    make: 'الماركة',
    model: 'الموديل',
    year: 'السنة',
    color: 'اللون',
    seats: 'المقاعد',
    transmission: 'ناقل الحركة',
    fuelType: 'نوع الوقود',
    pricePerDay: 'السعر في اليوم',
    description: 'الوصف',
    category: 'الفئة',
    selectCategory: 'اختر الفئة',
    location: 'موقع المركبة',
    selectLocation: 'اختر موقعاً',
    locationRequired: 'يرجى اختيار موقع',
    registrationNumber: 'رقم التسجيل',
    currentMileage: 'المسافة المقطوعة الحالية',
    insuranceExpiryDate: 'تاريخ انتهاء التأمين',
    technicalControlExpiryDate: 'تاريخ انتهاء الفحص الفني',
    circulationPermitExpiryDate: 'تاريخ انتهاء رخصة التداول',
    lastOilChangeDate: 'تاريخ آخر تغيير زيت',
    lastOilChangeMileage: 'المسافة المقطوعة عند آخر تغيير زيت',
    oilChangeIntervalKm: 'فترة تغيير الزيت (كم)',
    maintenanceNotes: 'ملاحظات الصيانة',
    features: 'المميزات',
    images: 'الصور',
    
    // Actions
    confirmDelete: 'هل أنت متأكد من أنك تريد حذف هذه المركبة؟',
    deleteConfirmTitle: 'حذف المركبة',
    deleteConfirmMessage: 'هل أنت متأكد من أنك تريد حذف هذه المركبة؟ لا يمكن التراجع عن هذا الإجراء.',
    deleteAllConfirmTitle: 'حذف المركبات المحددة',
    deleteAllConfirmMessage: 'هل أنت متأكد من أنك تريد حذف {{count}} مركبة محددة؟ لا يمكن التراجع عن هذا الإجراء.',
    cancel: 'إلغاء',
    
    // Status
    status: {
      available: 'متاح',
      rented: 'مؤجر',
      maintenance: 'صيانة',
    },
    
    // Transmission types
    transmissionType: {
      automatic: 'أوتوماتيكي',
      manual: 'يدوي',
    },
    
    // Fuel types
    fuelTypes: {
      gasoline: 'بنزين',
      diesel: 'ديزل',
      hybrid: 'هجين',
      electric: 'كهربائي',
    },
    
    // Categories
    categories: {
      economy: 'اقتصادية',
      compact: 'مدمجة',
      midsize: 'متوسطة',
      fullsize: 'كبيرة',
      luxury: 'فاخرة',
      suv: 'دفع رباعي',
    },
    
    // Success messages
    vehicleAdded: 'تم إضافة المركبة بنجاح',
    vehicleUpdated: 'تم تحديث المركبة بنجاح',
    vehicleDeleted: 'تم حذف المركبة بنجاح',
    vehiclesDeleted: 'تم حذف {{count}} مركبة بنجاح',
    
    // Error messages
    failedToAdd: 'فشل في إضافة المركبة. يرجى المحاولة مرة أخرى.',
    failedToUpdate: 'فشل في تحديث المركبة. يرجى المحاولة مرة أخرى.',
    failedToDelete: 'فشل في حذف المركبة. يرجى المحاولة مرة أخرى.',
    failedToUpload: 'فشل في رفع الصورة. يرجى المحاولة مرة أخرى.',
    
    // Validation messages
    makeRequired: 'الماركة مطلوبة',
    modelRequired: 'الموديل مطلوب',
    yearRequired: 'السنة مطلوبة',
    colorRequired: 'اللون مطلوب',
    categoryRequired: 'الفئة مطلوبة',
    transmissionRequired: 'ناقل الحركة مطلوب',
    fuelTypeRequired: 'نوع الوقود مطلوب',
    priceRequired: 'السعر في اليوم مطلوب',
    seatsRequired: 'عدد المقاعد مطلوب',
  },

  // Client Management
  clients: {
    title: 'إدارة العملاء',
    subtitle: 'إدارة عملائك وتاريخ التأجير الخاص بهم',
    addCustomer: 'إضافة عميل',
    addNewCustomer: 'إضافة عميل جديد',
    noClients: 'لم يتم العثور على عملاء',
    noClientsDesc: 'سيظهر العملاء هنا عندما يقومون بالحجوزات.',
    totalClients: 'تم العثور على {{count}} عميل/عملاء',
    searchPlaceholder: 'البحث بالاسم أو البريد الإلكتروني أو الهاتف أو رقم البطاقة...',
    stepOfTwo: 'الخطوة {{step}} من 2',
    selectAccountType: 'اختر نوع الحساب',
    chooseAccountTypeDesc: 'اختر نوع حساب العميل الذي تريد إنشاؤه',
    personalCustomerAccount: 'حساب عميل شخصي',
    businessCustomerAccount: 'حساب عميل تجاري',
    
    // Table headers
    client: 'العميل',
    phone: 'الهاتف',
    type: 'النوع',
    bookings: 'الحجوزات',
    spent: 'المبلغ المنفق',
    actions: 'الإجراءات',
    cin: 'رقم البطاقة الوطنية',
    viewCinImage: 'عرض صورة البطاقة الوطنية',
    
    // Client types
    individual: 'فرد',
    company: 'شركة',
    
    // Client details modal
    clientDetails: 'تفاصيل العميل',
    personalInformation: 'المعلومات الشخصية',
    joinedDate: 'تاريخ الانضمام',
    totalBookings: 'إجمالي الحجوزات',
    totalSpent: 'إجمالي المبلغ المنفق',
    recentBookings: 'الحجوزات الأخيرة',
    clientDocument: 'وثيقة العميل',
    identityDocument: 'وثيقة الهوية',
    downloadPDF: 'تحميل العقد + وثيقة الهوية',
    noImage: 'لا توجد صورة',
    noIdentityDocument: 'لا توجد وثيقة هوية متاحة',
    noBookings: 'لا توجد حجوزات بعد',
    
    // Form fields
    companyName: 'اسم الشركة',
    fullName: 'الاسم الكامل',
    phoneNumber: 'رقم الهاتف',
    identityCardNumber: 'رقم بطاقة الهوية (CIN)',
    drivingPermitNumber: 'رقم رخصة القيادة',
    iceNumber: 'رقم ICE',
    residencePermitNumber: 'رقم بطاقة الإقامة (Carte Séjour)',
    passportNumber: 'رقم جواز السفر',
    clientType: 'نوع العميل',

    // Placeholders
    enterCompanyName: 'أدخل اسم الشركة',
    enterFullName: 'أدخل الاسم الكامل',
    enterCompanyPhone: 'أدخل هاتف الشركة',
    enterPhone: 'أدخل رقم الهاتف',
    enterCIN: 'أدخل رقم البطاقة الوطنية',
    enterPassportNumber: 'أدخل رقم جواز السفر',
    enterResidencePermitNumber: 'أدخل رقم بطاقة الإقامة',
    enterDrivingPermitNumber: 'أدخل رقم رخصة القيادة (اختياري)',
    filterByRegistrationPeriod: 'تصفية حسب فترة التسجيل',
    passport: 'جواز السفر',
    enterPassport: 'أدخل رقم جواز السفر',
    enterResidencePermit: 'أدخل رقم بطاقة الإقامة',
    enterDrivingPermit: 'أدخل رقم رخصة القيادة',
    enterICE: 'أدخل رقم ICE (15 رقمًا)',
    
    // Status messages
    customerAdded: 'تم إضافة العميل بنجاح',
    customerUpdated: 'تم تحديث العميل بنجاح',
    failedToAdd: 'فشل في إضافة العميل. يرجى المحاولة مرة أخرى.',
    failedToUpdate: 'فشل في تحديث العميل. يرجى المحاولة مرة أخرى.',
    
    // Actions
    cancel: 'إلغاء',
    save: 'حفظ',
    update: 'تحديث',
    viewDetails: 'عرض التفاصيل',
    optionalForCompanies: 'اختياري للشركات',
    
    // ترجمات وثائق الهوية
    carteSejourShort: 'بطاقة الإقامة',
    selectOneIdentityDocument: 'يرجى اختيار وثيقة هوية واحدة فقط',
  },

  // Dashboard specific translations
  noCarsYet: 'لا توجد مركبات بعد',
  noCarsYetDesc: 'لم تقم بإضافة أي مركبات إلى أسطولك بعد. أضف مركبتك الأولى لبدء إدارة أعمال التأجير الخاصة بك.',
  categoryPerformance: 'أداء الفئات',
  
  // Dashboard cards and chart labels
  reservations: 'الحجوزات',
  revenue: 'الإيرادات',
  revenueEvolution: 'تطور الإيرادات (6 أشهر)',
  lastReservations: 'آخر الحجوزات',
  revenueMad: 'الإيرادات (درهم)',
  monthlyRevenue: 'الإيرادات الشهرية',
  customerSatisfaction: 'رضا العملاء',
  activeVehicles: 'المركبات النشطة',
  availableVehicles: 'المركبات المتاحة',
  revenueThisMonth: 'الإيرادات هذا الشهر',
  payments: 'المدفوعات',
  completed: 'مكتملة',
  outOf: 'من أصل',
  
  // Reports Section
  reports: {
    title: 'التقارير والتحليلات',
    topCarsByBookings: 'أفضل السيارات حسب الحجوزات',
    topCarsByRevenue: 'أفضل السيارات حسب الإيرادات',
    topClientsByPaid: 'أفضل العملاء حسب المبلغ المدفوع',
    topClientsByReservations: 'أفضل العملاء حسب الحجوزات',
    bookings: 'حجوزات',
    reservations: 'حجوزات',
    noData: 'لا توجد بيانات متاحة',
    completedAndConfirmedBookings: 'بناءً على الحجوزات المكتملة والمؤكدة',
    filterByStatus: 'تصفية حسب حالة الحجز:',
    showingStatusTypes: 'عرض',
    noStatusSelected: 'لم يتم اختيار أي حالة - يرجى اختيار حالة واحدة على الأقل لعرض البيانات',
    pleaseSelectStatus: 'يرجى اختيار حالة حجز واحدة على الأقل لعرض البيانات',
  },

  // Charts and analytics
  charts: {
    available: 'متاحة',
    rented: 'مؤجرة',
    maintenance: 'صيانة',
    vehicleStats: 'إحصائيات المركبات',
    availableVehicles: 'مركبات متاحة',
    pendingReservations: 'حجوزات في الانتظار',
    performance: 'الأداء'
  },
  
  // Performance metrics
  performanceMetrics: {
    occupancyRate: 'معدل الإشغال',
    customerSatisfaction: 'رضا العملاء',
    cancellationRate: 'معدل الإلغاء'
  },

  // Chart labels
  chartLabels: {
    performance: 'الأداء',
    maintenance: 'الصيانة'
  },

  // Dashboard analytics
  detailedAnalysis: 'تحليل مفصل لأداء الوكالة',
  vehicleStatus: 'حالة المركبات',
  bookingStatus: 'حالة الحجوزات',
  averageDuration: 'متوسط المدة',
  days: 'أيام',
  perRental: 'لكل إيجار',
  performanceIndicators: 'مؤشرات الأداء',
  occupancyRate: 'معدل الإشغال',
  cancellationRate: 'معدل الإلغاء',

  // Settings translations
  settings: {
    // Tab names
    general: 'عام',
    locations: 'المواقع',
    business: 'الأعمال',
    notifications: 'الإشعارات',
    
    // Main settings
    title: 'إعدادات الوكالة',
    subtitle: 'قم بتكوين ملف الوكالة وتفضيلاتك',
    settingsDescription: 'إدارة إعدادات الوكالة وساعات العمل وتفضيلات الإشعارات.',
    
    // Agency Information
    agencyInformation: 'معلومات الوكالة',
    agencyInformationDesc: 'المعلومات الأساسية حول وكالة تأجير السيارات',
    agencyLogo: 'شعار الوكالة',
    logoRecommendation: 'تحميل شعار الوكالة (الحجم المُوصى به: 200x200px)',
    
    // Financial Settings
    financialSettings: 'الإعدادات المالية',
    financialSettingsDesc: 'تكوين عملياتك المالية والتجارية',
    selectCurrency: 'اختر العملة',
    
    // Action buttons
    saveChanges: 'حفظ التغييرات',
  saving: 'جاري الحفظ...',
    savedSuccessfully: 'تم الحفظ بنجاح',
    errorSaving: 'خطأ في الحفظ',
    
    // Existing translations
    companyInformation: 'معلومات الشركة',
    companyInformationDesc: 'المعلومات الأساسية حول وكالة تأجير السيارات',
    agencyName: 'اسم الوكالة',
    agencyNamePlaceholder: 'أدخل اسم الوكالة',
    agencyDescription: 'وصف الوكالة',
    agencyDescriptionPlaceholder: 'وصف مختصر للوكالة',
    contactInformation: 'معلومات الاتصال',
    contactInformationDesc: 'كيف يمكن للعملاء الوصول إليك',
    phone: 'رقم الهاتف',
    phonePlaceholder: 'أدخل رقم الهاتف',
    email: 'عنوان البريد الإلكتروني',
    emailPlaceholder: 'أدخل عنوان البريد الإلكتروني',
    address: 'العنوان',
    addressPlaceholder: 'أدخل العنوان',
    city: 'المدينة',
    cityPlaceholder: 'أدخل المدينة',
    country: 'البلد',
    countryPlaceholder: 'أدخل البلد',
    businessSettings: 'إعدادات الأعمال',
    businessSettingsDesc: 'تكوين عمليات الأعمال',
    currency: 'العملة',
    taxRate: 'معدل الضريبة (%)',
    taxRateHelp: 'معدل الضريبة الافتراضي للحجوزات',
    workingHours: 'ساعات العمل',
    workingHoursDesc: 'تحديد ساعات عمل الوكالة',
    
    // Company Registration Information
    companyRegistration: 'تسجيل الشركة',
    companyRegistrationDesc: 'تفاصيل التسجيل القانوني للشركة',
    iceNumber: 'رقم ICE',
    iceNumberPlaceholder: 'أدخل رقم ICE (المعرف المشترك للمؤسسة)',
    rcNumber: 'رقم RC',
    rcNumberPlaceholder: 'أدخل رقم RC (السجل التجاري)',
    ifNumber: 'رقم IF',
    ifNumberPlaceholder: 'أدخل رقم IF (المعرف الضريبي)',
    
    openAlways: 'مفتوح 24/7',
    openAlwaysDescription: 'وكالتك مفتوحة بشكل مستمر، 24 ساعة في اليوم و 7 أيام في الأسبوع',
    openAllDay: 'مفتوح طوال اليوم',
    open: 'مفتوح',
    days: {
      monday: 'الإثنين',
      tuesday: 'الثلاثاء',
      wednesday: 'الأربعاء',
      thursday: 'الخميس',
      friday: 'الجمعة',
      saturday: 'السبت',
      sunday: 'الأحد'
    },
    close: 'إغلاق',
    closed: 'مغلق',
    uploadLogo: 'تحميل الشعار',
    uploadLogoDesc: 'تحميل شعار الوكالة (الحجم المُوصى به: 200x200px)',
    logoUploaded: 'تم تحميل الشعار بنجاح',
    logoUploadError: 'فشل في تحميل الشعار',
    
    // New notification preferences translations
    emailSettings: 'إعدادات البريد الإلكتروني',
    emailSettingsDesc: 'تكوين تفضيلات إشعارات البريد الإلكتروني',
    emailNotifications: 'إشعارات البريد الإلكتروني',
    emailNotificationsDesc: 'تمكين أو تعطيل جميع إشعارات البريد الإلكتروني',
    notificationEmail: 'بريد الإشعارات',
    notificationEmailPlaceholder: 'أدخل البريد الإلكتروني للإشعارات',
    notificationEmailHelp: 'إذا كان فارغاً، سيتم إرسال الإشعارات إلى بريد الوكالة',
    
    bookingNotifications: 'إشعارات الحجز',
    bookingNotificationsDesc: 'تكوين الإشعارات المتعلقة بالحجوزات',
    bookingPendingConfirmation: 'تأكيد معلق',
    bookingPendingConfirmationDesc: 'إشعار عند انتظار حجز للتأكيد',
    bookingReturnReminder: 'تذكير الإرجاع',
    bookingReturnReminderDesc: 'تذكير العملاء عند انتهاء فترة الإيجار',
    bookingOverdueAlerts: 'تنبيهات التأخير',
    bookingOverdueAlertsDesc: 'تنبيه عند عدم إرجاع المركبة في الوقت المحدد',
    
    maintenanceAlerts: 'تنبيهات الصيانة',
    maintenanceAlertsDesc: 'إشعارات صيانة المركبات والامتثال',
    maintenanceOilChange: 'تذكير تغيير الزيت',
    maintenanceOilChangeDesc: 'إشعار عند حاجة المركبات لتغيير الزيت',
    maintenanceInsuranceExpiry: 'انتهاء التأمين',
    maintenanceInsuranceExpiryDesc: 'تنبيه عند انتهاء صلاحية تأمين المركبة',
    maintenanceTechnicalControl: 'الفحص الفني',
    maintenanceTechnicalControlDesc: 'تذكير بالفحوصات الفنية الإلزامية',
    
    timingSettings: 'إعدادات التوقيت',
    timingSettingsDesc: 'تكوين متى يتم إرسال الإشعارات',
    pendingConfirmationRemindAfter: 'تذكير التأكيد المعلق',
    pendingConfirmationTimingHelp: 'دقائق بعد إنشاء الحجز لإرسال التذكير',
    returnReminderBefore: 'تذكير الإرجاع',
    returnReminderTimingHelp: 'دقائق قبل انتهاء الإيجار لإرسال التذكير',
    overdueAlertAfter: 'تنبيه التأخير',
    overdueAlertTimingHelp: 'دقائق بعد انتهاء الإيجار لإرسال التنبيه',
    minutes: 'دقيقة',
    
    saveNotificationSettings: 'حفظ إعدادات الإشعارات',
    saveNotificationSettingsDesc: 'تطبيق تفضيلات الإشعارات',
    
    notificationPreferences: 'تفضيلات الإشعارات',
    notificationPreferencesDesc: 'تكوين إعدادات الإشعارات',
    advancedNotificationTesting: 'اختبار نظام الإشعارات المتقدم',
    notificationTestingDesc: 'اختبار نظام الإشعارات المتقدم',
    testingFlowDescription: 'اختبار تدفق الإشعارات الكامل بما في ذلك إنشاء المهام وإرسال البريد الإلكتروني والتخزين في قاعدة البيانات:',
    testingFeatures: {
      emailNotifications: 'تسليم إشعارات البريد الإلكتروني',
      multilingualTemplates: 'قوالب بريد إلكتروني متعددة اللغات',
      jobCreation: 'إنشاء مهام الإشعارات',
      databaseStorage: 'التخزين والتتبع في قاعدة البيانات'
    },
    testingAdvancedNotifications: 'اختبار النظام...',
    testAdvancedNotificationSystem: 'اختبار نظام الإشعارات المتقدم',
    notificationJobsStatus: 'حالة مهام الإشعارات',
    notificationJobsDesc: 'عرض وإدارة مهام الإشعارات',
    noNotificationJobs: 'لا توجد مهام إشعارات حتى الآن',
    notificationJobsExplanation: 'ستظهر مهام الإشعارات هنا عند إنشاء حجوزات أو جدولة الصيانة.',
    notificationsSaved: 'تم حفظ تفضيلات الإشعارات بنجاح',
    
    // Username & URL translations
    usernameAndUrl: {
      title: 'اسم المستخدم وعنوان URL للوكالة',
      description: 'قم بتعيين اسم المستخدم المخصص الخاص بك للحصول على نطاق فرعي احترافي مثل YourUsername.kiracar.com يمكن للعملاء النقر عليه لزيارة وكالتك',
      subdomainUrl: 'عنوان URL للنطاق الفرعي الخاص بك',
      new: 'جديد',
      clickToVisit: 'انقر للزيارة • يعيد التوجيه إلى صفحة الوكالة الرئيسية',
      copy: 'نسخ',
      username: 'اسم المستخدم',
      usernameRequirements: '3-50 حرفاً، أحرف وأرقام وشرطات فقط',
      usernamePlaceholder: 'اسم-الوكالة-الخاص-بك',
      subdomainPreview: 'النطاق الفرعي الخاص بك: {{slug}}.kiracar.com',
      subdomainPreviewDesc: 'انقر للزيارة • يعيد التوجيه تلقائياً إلى صفحة الوكالة',
      generate: 'إنشاء',
      suggestions: 'اقتراحات:',
      saveUsername: 'حفظ اسم المستخدم',
      benefitsTitle: 'فوائد النطاق الفرعي المخصص الخاص بك',
      benefit1: 'نطاق فرعي احترافي (مثل YourAgency.kiracar.com)',
      benefit2: 'رابط قابل للنقر يفتح في تبويب جديد',
      benefit3: 'أسهل للعملاء في التذكر والمشاركة',
      benefit4: 'مثالي لبطاقات العمل والمواد التسويقية',
      benefit5: 'تحسين محركات البحث والظهور في البحث',
      benefit6: 'إعادة توجيه تلقائية إلى صفحة الوكالة',
      subdomainUrlCopied: 'تم نسخ رابط النطاق الفرعي إلى الحافظة!',
      agencyUrlCopied: 'تم نسخ رابط الوكالة إلى الحافظة!',
      usernameUpdatedSuccess: 'تم تحديث اسم المستخدم بنجاح!',
      usernameUpdateFailed: 'فشل في تحديث اسم المستخدم',
      testType: 'نوع الاختبار',
      selectTestType: 'اختر نوع الاختبار',
      basicEmailServiceTest: 'اختبار خدمة البريد الإلكتروني الأساسية',
      bookingNotificationTest: 'اختبار إشعار الحجز',
      maintenanceAlertTest: 'اختبار تنبيه الصيانة',
      enableEmailToTest: 'قم بتمكين إشعارات البريد الإلكتروني لاختبار النظام',
      testSuccessful: 'نجح الاختبار!',
      testFailed: 'فشل الاختبار',
      testEmailSentSuccess: 'تم إرسال بريد الاختبار بنجاح! معرف الرسالة: {{messageId}}',
      testEmailSendFailed: 'فشل في إرسال بريد الاختبار',
      testEmailError: 'حدث خطأ أثناء اختبار خدمة البريد الإلكتروني',
    },
  },

  // Customer information
  customerInformation: 'معلومات العميل',
  fullName: 'الاسم الكامل',
  notAvailable: 'غير متاح',
  editBooking: 'تعديل الحجز',
  
  // Read-only mode
  readOnlyInEditMode: 'للقراءة فقط في وضع التحرير',

  notifications: {
    title: 'الإشعارات',
    markAllAsRead: 'تحديد الكل كمقروء',
    noNotifications: 'لا توجد إشعارات',
    markAsReturned: 'تمّ الإسترجاع',
    editVehicle: 'تعديل المركبة',
    criticalAlerts: 'تنبيهات حرجة',
    processing: 'جاري المعالجة...',
    newNotification: 'إشعار جديد',
    priority: 'الأولوية',
    urgent: 'عاجل',
    important: 'مهم',
    normal: 'عادي',
    high: 'عالي',
    medium: 'متوسط',
    low: 'منخفض',
  },

  bookingScheduler: {
    updating: 'جاري التحديث...',
    autoSchedulerActive: 'الجدولة التلقائية نشطة',
    schedulerRunning: 'جاري فحص الحجوزات...',
  },

  // Missing common translations
  view: 'عرض',
  close: 'إغلاق',
  loading: 'جاري التحميل...',
  error: 'خطأ',
  success: 'نجح',
  save: 'حفظ',
  saving: 'جاري الحفظ...',

    // Add these new translations for the enhanced notification jobs
    totalJobs: 'إجمالي المهام',
    searchJobs: 'البحث في المهام...',
    allStatuses: 'جميع الحالات',
    allTypes: 'جميع الأنواع',
    pending: 'في الانتظار',
    executed: 'تم التنفيذ',
    failed: 'فشل',
    cancelled: 'ملغى',
    bookingReminder: 'تذكير الحجز',
    maintenanceAlert: 'تنبيه الصيانة',
    insuranceExpiry: 'انتهاء التأمين',
    technicalControl: 'الفحص التقني',
    oilChange: 'تغيير الزيت',
    noMatchingJobs: 'لا توجد مهام مطابقة',
    tryDifferentSearch: 'جرب تعديل البحث أو المرشحات',
    bookingId: 'معرف الحجز',
    carId: 'معرف السيارة',
    retries: 'المحاولات',
    created: 'تم الإنشاء',
    jobData: 'بيانات المهمة',
    errorMessage: 'رسالة الخطأ',
    cancelJob: 'إلغاء المهمة',
    retryJob: 'إعادة المحاولة',
    copyJobId: 'نسخ معرف المهمة',
    jobCancelled: 'تم إلغاء المهمة بنجاح',
    jobCancelError: 'خطأ في إلغاء المهمة',
    jobRetried: 'تم جدولة المهمة لإعادة المحاولة',
    jobRetryError: 'خطأ في إعادة محاولة المهمة',
    jobIdCopied: 'تم نسخ معرف المهمة إلى الحافظة',
    showingJobs: 'عرض {{start}}-{{end}} من {{total}} مهمة',
    status: {
      pending: 'في الانتظار',
      executed: 'تم التنفيذ',
      failed: 'فشل',
      cancelled: 'ملغى'
    },
    
  // Booking status translations for dashboard chart
  confirmedBookings: 'مؤكدة',
  pendingBookings: 'في الانتظار',
  completedBookings: 'مكتملة',
  cancelledBookings: 'ملغاة',
  
  // Time periods
  today: 'اليوم',
  todayShort: 'اليوم',
  thisWeek: 'هذا الأسبوع',
  clientsLabel: 'العملاء',
  viewCalendar: 'عرض التقويم',

};